export const SCORE_CONFIG = {
  distanceMultiplier: 12,
  survivalPerSecond: 95,
  pickupBonus: 650,
  championActivationBonus: 1200,
  championSecondBonus: 180,
  dangerSecondBonus: 80,
  songEnergyScorePerSecond: 165,
  songFinishBonus: 8500,
  victoryBonus: 12000,
  leaderboardSize: 10,
  aliasMaxLength: 12,
  schemaVersion: 2,
  storageKey: "run-campeon-aim-wind-x-records-v3-hardcore",
  deviceIdKey: "run-campeon-aim-wind-x-device-id",
  defaultName: "LOBO"
} as const;
